import { Loading } from "@/components/common";
import { KeycloakService } from "@/services/keycloakService";
import { useEffect, useState } from "react";

export const CallbackPage: React.FC = () => {
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading"
  );
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const params = KeycloakService.extractCallbackParams();

        if (params.error) {
          setStatus("error");
          setMessage(
            `Erro: ${params.error} - ${
              params.error_description || "Erro desconhecido"
            }`
          );
          return;
        }

        if (!params.code) {
          setStatus("error");
          setMessage("Código de autorização não encontrado na URL");
          return;
        }

        try {
          const tokenResponse = await KeycloakService.exchangeCodeForToken(
            params.code
          );

          KeycloakService.storeAccessToken(tokenResponse.access_token);

          try {
            const userInfo = await KeycloakService.getUserInfo();
            KeycloakService.storeUserInfo(userInfo);
          } catch (userError) {
            console.warn(
              "[KEYCLOAK-AUTH] Erro ao obter informações do usuário:",
              userError
            );
          }

          setStatus("success");

          setTimeout(() => {
            window.location.href = "/";
          }, 2000);
        } catch (tokenError) {
          setStatus("error");
          setMessage(
            `Erro ao obter access token: ${
              tokenError instanceof Error
                ? tokenError.message
                : "Erro desconhecido"
            }`
          );
        }
      } catch (error) {
        setStatus("error");
        setMessage(
          `Erro ao processar callback: ${
            error instanceof Error ? error.message : "Erro desconhecido"
          }`
        );
      }
    };

    handleCallback();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {status === "loading" && (
            <div className="flex justify-center mb-8">
              <Loading type="spinner" />
            </div>
          )}

          {status === "success" && (
            <div className="flex flex-col items-center justify-center py-12">
              <div className="flex items-center justify-center space-x-2 text-sm text-green-500">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span>Redirecionando para o sistema...</span>
              </div>
            </div>
          )}

          {status === "error" && (
            <div>
              <div className="bg-red-50 p-4 rounded-lg border border-red-200">
                <p className="text-red-700 text-sm">{message}</p>
              </div>
              <div className="mt-8 flex justify-center">
                <button
                  onClick={() => (window.location.href = "/")}
                  className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
                >
                  Voltar ao Login
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
